import {
  SUGGESTED_ACTION_TYPE,
  SuggestedActionType,
} from 'router/subrouters/DataRoom/models/Dashboard';

// URL query param keys used by the Suggested actions filters.
export const SUGGESTED_ACTIONS_HAS_ACTIONS_KEY = 'suggestedActionsHasActions';
export const SUGGESTED_ACTIONS_ACTION_TYPE_KEY = 'suggestedActionsActionType';

export const HAS_ACTIONS_FILTER = {
  ALL: 'all',
  WITH_ACTIONS: 'true',
  WITHOUT_ACTIONS: 'false',
} as const;

// Translation keys for each action type shown in the multi-select filter.
export const SUGGESTED_ACTION_TYPE_LABEL: Record<SuggestedActionType, string> =
  {
    [SUGGESTED_ACTION_TYPE.DATA_ROOM_EMPTY]: 'suggestedActionFilterEmptyDataRoom',
    [SUGGESTED_ACTION_TYPE.NO_FILES_LAST_10_DAYS]:
      'suggestedActionFilterNoNewFiles',
    [SUGGESTED_ACTION_TYPE.UNREPLIED_QUESTIONS]:
      'suggestedActionFilterUnrepliedQuestions',
    [SUGGESTED_ACTION_TYPE.NO_FAQS]: 'suggestedActionFilterNoFaqs',
    [SUGGESTED_ACTION_TYPE.PEOPLE_IN_WAITING_ROOM]:
      'suggestedActionFilterPeopleInWaitingRoom',
    [SUGGESTED_ACTION_TYPE.SECURE_LINKS_EXPIRING]:
      'suggestedActionFilterExpiringSecureLinks',
    [SUGGESTED_ACTION_TYPE.NEW_FILE_REQUEST]:
      'suggestedActionFilterNewFileRequest',
    [SUGGESTED_ACTION_TYPE.EMPTY_SECURE_LINKS]:
      'suggestedActionFilterEmptySecureLink',
    [SUGGESTED_ACTION_TYPE.UNREAD_MESSAGES]:
      'suggestedActionFilterUnreadMessages',
    [SUGGESTED_ACTION_TYPE.UNREAD_LEAD_NOTES]:
      'suggestedActionFilterUnreadLeadNotes',
    [SUGGESTED_ACTION_TYPE.UNREAD_DEAL_NOTES]:
      'suggestedActionFilterUnreadDealNotes',
  };

// Order in which the action types are listed in the filter.
export const SUGGESTED_ACTION_TYPE_ORDER: SuggestedActionType[] = [
  SUGGESTED_ACTION_TYPE.DATA_ROOM_EMPTY,
  SUGGESTED_ACTION_TYPE.NO_FILES_LAST_10_DAYS,
  SUGGESTED_ACTION_TYPE.UNREPLIED_QUESTIONS,
  SUGGESTED_ACTION_TYPE.NO_FAQS,
  SUGGESTED_ACTION_TYPE.PEOPLE_IN_WAITING_ROOM,
  SUGGESTED_ACTION_TYPE.SECURE_LINKS_EXPIRING,
  SUGGESTED_ACTION_TYPE.NEW_FILE_REQUEST,
  SUGGESTED_ACTION_TYPE.EMPTY_SECURE_LINKS,
  SUGGESTED_ACTION_TYPE.UNREAD_MESSAGES,
  SUGGESTED_ACTION_TYPE.UNREAD_LEAD_NOTES,
  SUGGESTED_ACTION_TYPE.UNREAD_DEAL_NOTES,
];
